/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowUiShareAExportIcon16Light = forwardRef('ArrowUiShareAExportIcon16Light', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M13.254 1.146a.5.5 0 0 0-.708.708L14.693 4H11.45A4.45 4.45 0 0 0 7 8.45v.05a.5.5 0 0 0 1 0v-.05A3.45 3.45 0 0 1 11.45 5h3.243l-2.147 2.146a.5.5 0 0 0 .708.708l2.292-2.293a1.5 1.5 0 0 0 0-2.122l-2.292-2.293Z" }),
        React.createElement("path", { d: "M2 5a3 3 0 0 1 3-3h2a.5.5 0 0 1 0 1H5a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2v-1a.5.5 0 0 1 1 0v1a3 3 0 0 1-3 3H5a3 3 0 0 1-3-3V5Z" })));
});
